import React, { ForwardRefRenderFunction, forwardRef } from "react";
//#region types
import { FormEnums } from "models/enums";
import { FormHandles } from "models/propTypes/genericFormProps";
import { TranslationKeys } from "translations";
import { PaymentFormTypes } from "models/formTypes";
import { StoppedPaymentsTodoSelectionFormViewProps } from "models/propTypes/paymentPropTypes";
import { GenericFormSection } from "models/propTypes/genericFormProps";
//#endregion
//#region components
import { GenericForm } from "components/common";
import { LocalizationHelperInstance } from "utils/helpers";
//#endregion

const StoppedPaymentsTodoSelectionForm: ForwardRefRenderFunction<
  FormHandles,
  StoppedPaymentsTodoSelectionFormViewProps
> = (props, ref) => {
  const fields: GenericFormSection<PaymentFormTypes.StoppedPaymentTodo>[] = [
    {
      label: TranslationKeys.Payments.NewPayoutDate,
      type: FormEnums.FormSectionType.EXPANDABLESECTION,
      innerFields: {
        newPayoutDate: {
          label: TranslationKeys.Common.PaymentDate,
          type: FormEnums.FormFieldType.DATE,
        },
      },
      extraProps: {
        summaryFormatter: (values: PaymentFormTypes.StoppedPaymentTodo) =>
          LocalizationHelperInstance.getFormattedDate(values.newPayoutDate),
      },
    },
  ];

  return <GenericForm<PaymentFormTypes.StoppedPaymentTodo> formRef={ref} {...props} fields={fields} hideSuccess />;
};

export default forwardRef(StoppedPaymentsTodoSelectionForm);
